import { Form } from 'factorial-form'

class LeaveDayTypeForm extends Form {
  constructor(values: {}) {
    super(values, {
      day_type: 'string',
    })
  }
}

export default LeaveDayTypeForm
